
// TODO
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      vxTrendingTerms: 'search/getTrendingTerms',
      vxStoryContent: 'search/getStoryContent',
    }),
  },
  methods: {
    ...mapActions({
      vxResetAllSearch: 'search/resetAllSearch',
    }),
  },
}
